import { useEffect } from "react"


export const useGetUniqueOptions = (setDD, data, field) => {
  useEffect(() => {
    if (data && field) {
      const check = []
      const options = [{value: 0, label: "All"}]
      data.forEach(d => {
        if (check.indexOf(d[field]) === -1) {
          options.push({value: d.id, label: d[field]})
          check.push(d[field])
        }
      })
      setDD(options)
    }
  }, [data, field, setDD])
}